export const NO_FILE = 'NO_FILE';
export const PASS = 'PASS';
